<template>
  <div id="app" v-bind:class="{updating: updating}">
    <RdsHeader></RdsHeader>
    <transition name="menu-slide-right">
      <RdsMenu v-if="showMenu"></RdsMenu>
    </transition>
    <transition name="menu-slide-bottom">
      <RdsNotifications
        v-bind:showNavettaReport="showNavettaReport"
        v-bind:showNotifications="showNotifications"
        v-if="showNotificationWrapper"
      ></RdsNotifications>
    </transition>
    <BeaconReader v-if="showBeaconReader"></BeaconReader>
    <transition v-bind:name="transitionName" mode="out-in">
      <router-view class="main" />
    </transition>
    <RdsFooter></RdsFooter>
    <div class="overlay">
      <RdsLoader class="rds-loader"></RdsLoader>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import RdsHeader from '@/components/RdsHeader.vue';
import RdsFooter from '@/components/RdsFooter.vue';
import RdsLoader from '@/components/RdsLoader.vue';
import RdsMenu from '@/components/RdsMenu';
import RdsNotifications from '@/components/RdsNotifications';
import BeaconReader from './components/BeaconReader';
import { eventBus } from './services/EventBus';
import store from './stores';

export default {
  name: 'home',
  components: {
    RdsHeader,
    RdsFooter,
    RdsLoader,
    RdsMenu,
    RdsNotifications,
    BeaconReader
  },
  data() {
    return {
      updating: false,
      showMenu: false,
      showNotificationWrapper: false,
      showNavettaReport: false,
      showNotifications: false,
      showBeaconReader: !!window.cordova,
      cache: store.cache
    };
  },
  computed: {
    transitionName() {
      return this.$route.name !== 'home' ? 'slide-right' : 'slide-left';
    },
    notificationNumber() {
      return this.cache.notifications.length;
    }
  },
  created() {
    eventBus.$on('updating', () => {
      this.updating = true;
    });
    eventBus.$on('updated', () => {
      this.updating = false;
    });
    eventBus.$on('toogleMenuProfile', () => {
      this.showMenu = !this.showMenu;
    });
    eventBus.$on('hideMenuProfile', () => {
      this.showMenu = false;
    });
    eventBus.$on('showNotifications', () => {
      this.showNotificationWrapper = true;
      this.showNotifications = true;
    });
    eventBus.$on('hideNotifications', () => {
      this.showNotificationWrapper = false;
      this.showNotifications = false;
    });
    eventBus.$on('toggleNotifications', () => {
      this.showNotificationWrapper = !this.showNotifications;
      this.showNotifications = !this.showNotifications;
    });
    eventBus.$on('showNavettaReport', () => {
      this.showNotificationWrapper = true;
      this.showNavettaReport = true;
    });
    eventBus.$on('hideNavettaReport', () => {
      this.showNotificationWrapper = false;
      this.showNavettaReport = false;
    });
    eventBus.$on('toggleNavettaReport', () => {
      this.showNotificationWrapper = !this.showNavettaReport;
      this.showNavettaReport = !this.showNavettaReport;
    });
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/main.scss';
.overlay {
  // background: #e9e9e9;
  opacity: 1;
  background-image: linear-gradient(to top, #dfe9f3 0%, white 100%);
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  .rds-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
#app.updating {
  .overlay {
    display: block;
  }
}
.menu-slide-right-enter-active,
.menu-slide-right-leave-active {
  transition: transform 0.2s;
}
.menu-slide-right-enter {
  transform: translateX(-100%);
}
.menu-slide-right-leave-to {
  transform: translateX(-100%);
}

.menu-slide-bottom-enter-active,
.menu-slide-bottom-leave-active {
  transition: all 0.2s;
}
.menu-slide-bottom-enter {
  transform: translateY(-100%);
  opacity: 0;
}
.menu-slide-bottom-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
